import React from "react";
import GooglePicker from "react-google-picker";
const UploadButtonStyle = {
  backgroundColor: "#4EA5DC",
  borderRadius: "5px",
  minWidth: "100%",
  height: "60px",
  color: "white",
};

const Upload = () => {
  return (
    <>
      <GooglePicker
        clientId={
          "372697091105-1j8ermai3o7gpjh82vt5iho35osbapc4.apps.googleusercontent.com"
        }
        developerKey={"AIzaSyBq02OHAAbgw7I33Gdr91l3LtG4IVmO9UU"}
        scope={
          (["https://www.googleapis.com/auth/drive.file"],
          ["https://www.googleapis.com/auth/drive"])
        }
        onChange={(data) => console.log("on change:", data)}
        onAuthFailed={(data) => console.log("on auth failed:", data)}
        multiselect={true}
        navHidden={true}
        authImmediate={false}
        viewId={"DOCS"}
        mimeTypes={["image/png", "image/jpeg", "image/jpg"]}
        createPicker={(google, oauthToken) => {
          const googleViewId = google.picker.ViewId.DOCS;
          const uploadView = new google.picker.DocsUploadView().setIncludeFolders(
            true
          );
          const docsView = new google.picker.DocsView(googleViewId)
            .setIncludeFolders(true)
            .setSelectFolderEnabled(true);
          const picker = new window.google.picker.PickerBuilder()
            .enableFeature(google.picker.Feature.SIMPLE_UPLOAD_ENABLED)
            .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
            .addView(docsView)
            .addView(uploadView) /*DocsUploadView added*/
            .setOAuthToken(oauthToken)
            .setDeveloperKey("AIzaSyBq02OHAAbgw7I33Gdr91l3LtG4IVmO9UU")
            .setCallback((data) => {
              if (data.action === google.picker.Action.PICKED) {
                var fileId = data.docs[0].id;
                alert("The user selected: " + fileId);
              }
            });
          picker.build().setVisible(true);
        }}
      >
        <button style={UploadButtonStyle}>UPLOAD</button>
        <div className="google"></div>
      </GooglePicker>
    </>
  );
};

export default Upload;
